module.exports = __webpack_public_path__ + "static/media/chhattisgarh.b30de3de.png";